// Duplicated config from front-office/scopes/legal
export const LEGAL_PAGE_NAME = {
  DATA_PROTECTION: 'data-protection',
  BUYBACK: 'terms-of-trade-in',
  TERMS_SALE: 'terms-of-sale',
  TERMS_USE: 'terms-of-use',
  TERMS_SERVICE: 'terms-of-service',
  WARRANTY: 'warranty',
  LEGAL_MENTIONS: 'legal-mentions',
}

export const CMS = {
  LEGAL_PAGE: 'legal',
} as const
